import styled from 'styled-components';
import { Container } from '../../styles/Common';

const BoxWrapper2 = () => {
  return (
    <Wrapper>
      <Container>
        <InnerMain>
          <SingleCard>
            <img src="/assets/icons/cloud-square.png" alt="cloud-square" />
            <h3>Fast & Efficient Delivery</h3>
            <p>
              Fast & Efficient Delivery We enhance our operations by relieving
              you of the worries.
            </p>
          </SingleCard>
          <SingleCard>
            <img src="/assets/icons/cloud-square.png" alt="cloud-square" />
            <h3>Secure Inventory</h3>
            <p>
              Secure Inventory We store your inventory securely in our
              fulfillment centers
            </p>
          </SingleCard>
          <SingleCard>
            <img src="/assets/icons/cloud-square.png" alt="cloud-square" />
            <h3>Transparent Pricing</h3>
            <p>
              Transparent Pricing International supply chains involves
              challenging regulations.
            </p>
          </SingleCard>
          <SingleCard>
            <img src="/assets/icons/cloud-square.png" alt="cloud-square" />
            <h3>Real-Time Tracking</h3>
            <p>
              Real-Time Tracking Ensure customers' supply chains are fully
              compliant by practices.
            </p>
          </SingleCard>
        </InnerMain>
      </Container>
    </Wrapper>
  );
};

export default BoxWrapper2;

const Wrapper = styled.div`
  padding: 0;

  @media (max-width: 576px) {
    padding: 0 15px;
  }
`;

const InnerMain = styled.div`
  background: #5da5ed;
  border-radius: 6px;
  padding: 35px 45px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 576px) {
    padding: 20px;
  }
`;

const SingleCard = styled.div`
  width: 265px;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 0;

  img {
    width: 62px;
    height: auto;
    margin-bottom: 25px;
  }

  h3 {
    font-weight: 700;
    font-size: 22px;
    font-family: font-bold;
    color: #ffffff;
    margin-bottom: 20px;
    text-align: left;
  }

  p {
    font-weight: 500;
    font-size: 16px;
    font-family: font-medium;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.8;
    letter-spacing: 1px;
    text-align: left;
  }

  @media (max-width: 576px) {
    width: 100%;
    align-items: center;
    margin-bottom: 40px;

    img {
      width: 55px;
      height: auto;
      margin-bottom: 15px;
    }

    h3 {
      margin-bottom: 10px;
      text-align: center;
    }

    p {
      font-weight: 500;
      font-size: 16px;
      font-family: font-medium;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.8;
      letter-spacing: 1px;
      text-align: center;
    }
  }
`;
